import { load } from "@cashfreepayments/cashfree-js";
import api from "@/lib/api";
import { toast } from "sonner";

export function fmtLocalDate(d) {
  if (!d) return "";
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

let _cashfree = null;
async function getCashfree(mode) {
  if (!_cashfree) _cashfree = await load({ mode });
  return _cashfree;
}

/** Create the order, open Cashfree checkout and verify the result server-side. */
export async function payForBooking(bookingId) {
  const order = await api.post("/payments/create-order", { booking_id: bookingId });
  if (order.data.mocked) {
    toast.success("Payment confirmed (MOCKED). Slot secured.");
    return { paid: true, mocked: true };
  }
  const sessionId = order.data.payment_session_id;
  const orderId = order.data.order_id;
  if (!sessionId) throw new Error("Payment session unavailable");

  const cashfree = await getCashfree(order.data.mode === "production" ? "production" : "sandbox");
  const result = await cashfree.checkout({ paymentSessionId: sessionId, redirectTarget: "_modal" });
  if (result?.error) {
    toast.error(result.error.message || "Payment was not completed");
  }
  const status = await api.get(`/payments/${orderId}/status`);
  if (status.data.paid) toast.success("Payment received — your booking is confirmed.");
  else toast.error(`Payment ${String(status.data.order_status || "incomplete").toLowerCase()}. You can retry from My Bookings.`);
  return { paid: !!status.data.paid, order_status: status.data.order_status };
}
